import React from 'react';
import { Box, TextField } from '@mui/material';
import SharedFormFields, { SharedFormData } from './SharedFormFields';
import GlassICPSelector from './GlassICPSelector';
import { glassTextField, getStaggeredAnimation } from './glassMorphismStyles';

export interface IdeaFormData extends SharedFormData {
  topic: string;
  icpId: string;
}

interface IdeaFormFieldsProps {
  formData: IdeaFormData;
  onChange: (field: string, value: string) => void;
  errors?: Record<string, string>;
}

const IdeaFormFields: React.FC<IdeaFormFieldsProps> = ({
  formData,
  onChange,
  errors = {},
}) => {
  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.name, event.target.value);
  };

  const handleICPChange = (value: string) => {
    onChange('icpId', value);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, sm: 1.5 } }}>
      {/* Shared fields (Platform, Brand, Sector) */}
      <SharedFormFields
        formData={formData}
        onChange={onChange}
        errors={errors}
        animationBaseDelay={0}
      />

      {/* Topic Field */}
      <TextField
        fullWidth
        size="small"
        name="topic"
        label="Topic *"
        placeholder="What would you like to post about?"
        value={formData.topic}
        onChange={handleTextChange}
        error={!!errors.topic}
        helperText={errors.topic}
        multiline
        minRows={1}
        maxRows={2}
        sx={{
          ...glassTextField,
          ...getStaggeredAnimation(4, 0),
        }}
      />

      {/* Persona Selector */}
      <GlassICPSelector
        value={formData.icpId}
        onChange={handleICPChange}
        error={errors.icpId}
        animationDelay={500}
      />
    </Box>
  );
};

export default IdeaFormFields;
